export { cn } from '@zerohuman/ui'

/**
 * Get a nested value from an object using a dot-separated path.
 * @example getNestedValue({ a: { b: 'c' } }, 'a.b') // 'c'
 */
// biome-ignore lint/suspicious/noExplicitAny: Generic utility function needs flexible types
export function getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((current, key) => current?.[key], obj)
}
